export default {
  hsk: 'HSK Words',
  'hsk-chars': 'HSK Chars',
  tocfl: 'TOCFL Words',
  'tocfl-chars': 'TOCFL Chars',
  'rank-chars': 'Char Freqs',
};
